import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { compose } from 'recompose';
import { withFirebase } from '../Firebase';

import { AuthUserContext, withAuthorization } from '../Session';

import 'react-tabs/style/react-tabs.css';

const HomePage = () => (
  <AuthUserContext.Consumer>
    {authUser => (
      <div>
        <h1>Account: {authUser.email}</h1>
        <ValueCampaignForm authUser={authUser} />
      </div>
    )}
  </AuthUserContext.Consumer>
);

class ValueCampaignFormBase extends React.Component {
  constructor(props) {
    super(props);

    this.unsub = null
    this.companyUnsub = null

    this.state = {
        company: null,
        loading: false,
        visits: [],
        campaignType: '',
        offerValue: '',
        visitedMoreThanValue: '',
        visitedLessThanValue: '',
        spentMoreThanValue: '',
        spentLessThanValue: '',
        activeOrInactive: '',
        inLastValue: '',
        city: '',
        storeId: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.companyUnsub = this.props.firebase.company(this.props.authUser.uid).onSnapshot(docSnapshot => {
                          console.log(`Received doc snapshot: ${docSnapshot}`);
                          this.setState({
                            company: docSnapshot.data()
                          });
                        }, err => {
                          console.log(`Encountered error: ${err}`);
                        });

    this.unsub = this.props.firebase.visits(this.props.authUser.uid).onSnapshot(snapshot => {
            console.log(`Received query snapshot of size ${snapshot.size}`);

            if (snapshot.empty) {
                console.log('No matching documents.');
                return;
            }

            const visitsList = [];
              snapshot.forEach(doc => {
                const { uid, firstName, companyUid, count, value } = doc.data();
                visitsList.push({
                    id: doc.id,
                    uid,
                    firstName,
                    companyUid,
                    count,
                    value,
                });
              })

              this.setState({
                visits: visitsList,
                loading: false,
              });
        }, err => {
            console.log(`Encountered error: ${err}`);
        }
  );
  }

  componentWillUnmount() {
    if(this.unsub !== null) this.unsub()
    if(this.companyUnsub !== null) this.companyUnsub()
  }

  handleChange(event) {
    this.setState({
        campaignType: event.target.campaignType,
        offerValue: event.target.offerValue,
        visitedMoreThanValue: event.target.visitedMoreThanValue,
        visitedLessThanValue: event.target.visitedLessThanValue,
        spentMoreThanValue: event.target.spentMoreThanValue,
        spentLessThanValue: event.target.spentLessThanValue,
        activeOrInactive: event.target.activeOrInactive,
        inLastValue: event.target.inLastValue,
        city: event.target.city,
        storeId: event.target.storeId
    });
  }

  handleSubmit(event) {
    alert('A name was submitted: ' + this.state.value);

    event.preventDefault();
  }

  render() {
    const { company, visits, loading } = this.state;

    return (
      <div>
      <Tabs>
        <TabList>
          <Tab>Value Campaign</Tab>
          <Tab>Time Campaign</Tab>
        </TabList>

        <TabPanel>
          <form onSubmit={this.handleSubmit}>
            <label>
            All customer:
              <br/>
              Visits #: <input type="text" value={this.state.visitedMoreThanValue} onChange={this.handleChange} /> - <input type="text" value={this.state.visitedLessThanValue} onChange={this.handleChange} />
              <br/>
              Spent value: <input type="text" value={this.state.spentMoreThanValue} onChange={this.handleChange} /> - <input type="text" value={this.state.spentLessThanValue} onChange={this.handleChange} />
              <br/>
              City: <input type="text" value={this.state.city} onChange={this.handleChange} />
              <br/>
              Store ID: <input type="text" value={this.state.storeId} onChange={this.handleChange} />
              <br/>
              Offer:<br/>
              <textarea value={this.state.offerValue} onChange={this.handleChange} cols="60" rows="5" />
              <br/>
              Image: <input type="file" /><br/>
            </label>
            <input type="submit" value="Preview" />
          </form>
        </TabPanel>
        <TabPanel>
          <form onSubmit={this.handleSubmit}>
            <label>
            All customer:
              <br/>
              <select value={this.state.activeOrInactive} onChange={this.handleChange}>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select> in last <input type="text" value={this.state.inLastValue} onChange={this.handleChange} /> months
              <br/>
              City: <input type="text" value={this.state.city} onChange={this.handleChange} />
              <br/>
              Store ID: <input type="text" value={this.state.storeId} onChange={this.handleChange} />
              <br/>
              Offer:<br/>
              <textarea value={this.state.offerValue} onChange={this.handleChange} cols="60" rows="5"/>
              <br/>
              Image: <input type="file" /><br/>
            </label>
            <input type="submit" value="Preview" />
          </form>
        </TabPanel>
      </Tabs>
      Account Balance: {company != null ? company.accountBalance : ''}
        <h1>Home</h1>

        {loading && <div>Loading ...</div>}

        <div>
          Company: {company != null ? company.name : ''} <br/>
          Visits {visits.length}:
            {visits.map(function(visit, i){
            return <div>{visit.uid}, {visit.firstName}, {visit.count}, {visit.value} </div>;
        })}
        </div>
      </div>
    );
  }
}

const ValueCampaignForm = withFirebase(ValueCampaignFormBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(HomePage);
